import rules from "./toelatings";

const kryBittoelatingsUitBlok = (bittoelatings, bittoelatingsblok) => {
  return bittoelatings[
    `bittoelatings_${String.fromCharCode(
      "a".charCodeAt(0) + parseInt(bittoelatingsblok, 10)
    )}`
  ];
};

const kryToelatingItems = (permissionsneeded) => {
  let masks = [];
  for (let i = 0; i < Object.keys(permissionsneeded).length; i++) {
    var result = rules.find((obj) => obj.rule === permissionsneeded[i]);
    if (result) {
      masks.push(result);
    }
  }
  return masks;
};

const check = (permissionsowned, permissionsneeded) => {
  if (permissionsneeded.length > 0) {
    let allowed = false;
    let bitmasks = kryToelatingItems(permissionsneeded);
    for (let i = 0; i < bitmasks.length; i++) {
      let bitmaskresult = kryBittoelatingsUitBlok(
        permissionsowned,
        bitmasks[i].blok
      );
      if (
        parseInt(bitmasks[i].bitmask, 10) ===
        ((bitmaskresult & parseInt(bitmasks[i].bitmask, 10)) < 0
          ? 2147483648
          : bitmaskresult & parseInt(bitmasks[i].bitmask, 10))
      ) {
        allowed = true;
      }
    }
    return allowed;
  } else {
    return true;
  }
};

const Any = ({ permissionsowned, permissionsneeded, yes = () => null, no = () => null }) =>
  check(permissionsowned, permissionsneeded)
    ? yes()
    : no();

export default Any;
